import { Typography } from "@mui/material";

import { useAnalytics } from "@/providers/analytics";
import { isTemporaryLayout, LayoutRecord } from "@/shared/domain/layouts";
import { usePrefetchLayouts } from "@/shared/domain/layouts/hooks";
import { KeyboardArrowDownIcon } from "@/shared/foundation/icons/mui";
import { usePopupState } from "@/shared/hooks";
import { ErrorMonitoringService } from "@/shared/services/ErrorMonitoringService";

import { SelectLayout } from "../SelectLayout";

import styles from "./SelectActiveLayout.module.css";

interface SelectActiveLayoutProps {
  activeLayout: LayoutRecord;
}

export function SelectActiveLayout({ activeLayout }: SelectActiveLayoutProps) {
  const layoutMenuPopup = usePopupState();
  const { trackEvent } = useAnalytics();

  const prefetchLayouts = usePrefetchLayouts();

  return (
    <>
      <div
        className={styles.layoutButton}
        role="button"
        tabIndex={0}
        onClick={(event) => {
          trackEvent("SelectLayoutMenuOpened");
          layoutMenuPopup.open({ anchorEl: event.currentTarget });
        }}
        onKeyDown={(event) => {
          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            trackEvent("SelectLayoutMenuOpened");
            layoutMenuPopup.open({ anchorEl: event.currentTarget });
          }
        }}
        onMouseEnter={() => {
          // Pre-fetch the layouts when the user hovers over the button
          void prefetchLayouts().catch((err) => {
            ErrorMonitoringService.captureError(err);
          });
        }}
        aria-haspopup="menu"
        aria-expanded={layoutMenuPopup.isOpen}
        aria-label={`The current layout is ${activeLayout.name}. Click to change layout`}
      >
        <Typography variant="body1" noWrap className={styles.layoutName}>
          {isTemporaryLayout(activeLayout)
            ? "No layout selected"
            : activeLayout.name}
        </Typography>
        <KeyboardArrowDownIcon
          sx={{ color: "grey.500", fontSize: "1.25rem" }}
        />
      </div>

      <SelectLayout
        anchorEl={layoutMenuPopup.anchor}
        isOpen={layoutMenuPopup.isOpen}
        onClose={layoutMenuPopup.close}
      />
    </>
  );
}
